import React, { useState, useEffect } from 'react';
import { Organization } from '../../models/organization';
import OrganizationList from './OrganizationList';
//import OrganizationForm from './OrganizationForm';
import StoreList from '../Store/StoreList';
import axios from "../../axios-config";

const OrganizationEditor: React.FC = () => {
    const [organizations, setOrganizations] = useState<Organization[]>([]);
    const [newOrganization, setNewOrganization] = useState<Partial<Organization>>({ organizationName: '', pointsAvailable: 0, mascotName: '', organizationSlug: '' });
    const [editingOrganization, setEditingOrganization] = useState<Partial<Organization> | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        fetchOrganizations();
    }, []);

    const fetchOrganizations = async () => {
        setIsLoading(true);
        try {
            const { data } = await axios.get('/api/organizations', { withCredentials: true });
            // Ensure we're setting an array to state
            setOrganizations(Array.isArray(data) ? data : (data?.organizations || []));
        } catch (error) {
            console.error('Error fetching organizations:', error);
            setOrganizations([]);
        } finally {
            setIsLoading(false);
        }
    };

    const createOrganization = async () => {
        try {
            const { data } = await axios.post('/api/organizations', newOrganization, { withCredentials: true });
            setOrganizations([...organizations, data]);
            setNewOrganization({ organizationName: '', pointsAvailable: 0, mascotName: '', organizationSlug: '' });
        } catch (error) {
            console.error('Error creating organization:', error);
        }
    };

    const updateOrganization = async (organizationId: string) => {
        try {
            const { data } = await axios.put(`/api/organizations/${organizationId}`, editingOrganization, { withCredentials: true });
            setOrganizations(organizations.map(org => (org.organizationId === organizationId ? data : org)));
            setEditingOrganization(null);
        } catch (error) {
            console.error('Error updating organization:', error);
        }
    };

    const deleteOrganization = async (organizationId: string) => {
        try {
            await axios.delete(`/api/organizations/${organizationId}`, { withCredentials: true });
            setOrganizations(organizations.filter(org => org.organizationId !== organizationId));
        } catch (error) {
            console.error('Error deleting organization:', error);
        }
    };

    return (
        <div className="container mx-auto p-6">
            <p><a href="/" className="text-blue-500 hover:underline">Back</a></p>
            <h1 className="text-3xl font-bold mb-6 text-center">Organization</h1>
            <button
                onClick={createOrganization}
                className="bg-green-500 hover:bg-green-600 text-white font-semibold px-4 py-2 rounded mb-6"
            >
                Add Organization
            </button>
            {/* Organization Form */}
            {/* <OrganizationForm
                newOrganization={newOrganization}
                setNewOrganization={setNewOrganization}
            /> */}
            {/* Organizations Table */}
            <table className="min-w-full bg-white border border-gray-200 mb-6">
                <thead className="bg-gray-100">
                    <tr>
                        <th className="px-4 py-2 border-b">Name</th>
                        <th className="px-4 py-2 border-b">Location</th>
                        <th className="px-4 py-2 border-b">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        <tr>
                            <td colSpan={3} className="px-4 py-2 text-center">Loading organizations...</td>
                        </tr>
                    ) : !Array.isArray(organizations) || organizations.length === 0 ? (
                        <tr>
                            <td colSpan={3} className="px-4 py-2 text-center">No organizations found</td>
                        </tr>
                    ) : (
                        organizations.map(org => (
                            <tr key={org.organizationId} className="text-center">
                                <td className="px-4 py-2 border-b">{org.organizationName}</td>
                                <td className="px-4 py-2 border-b">{org.location}</td>
                                <td className="px-4 py-2 border-b space-x-2">
                                    <button
                                        onClick={() => setEditingOrganization(org)}
                                        className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
                                    >
                                        Edit
                                    </button>
                                    <button
                                        onClick={() => deleteOrganization(org.organizationId)}
                                        className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
            <OrganizationList
                organizations={Array.isArray(organizations) ? organizations : []}
                editingOrganization={editingOrganization}
                setEditingOrganization={setEditingOrganization}
                updateOrganization={updateOrganization}
                deleteOrganization={deleteOrganization}
            />
            {editingOrganization && <StoreList 
                stores={editingOrganization.stores || []} 
                onEdit={(store) => console.log("Edit store", store)}
                onDelete={(storeId) => console.log("Delete store", storeId)}
                onProducts={(storeId) => console.log("View products", storeId)}
            />}
        </div>
    );
};

export default OrganizationEditor;
